import { PageBody } from '../components/shell/PageBody.tsx';
import { OpsHealthView } from '../features/ops-health/OpsHealthView.tsx';
import { WhenRuns } from '../features/server/ModuleAbsent.tsx';

/** Orgus health (ORGU-182): the last heartbeat of each of Orgus's own loops. */
export default function Health() {
  return (
    <WhenRuns module="ops-health" feature="Orgus health" instead="Orgus Watch still lists incidents." size="page">
      <PageBody>
        <OpsHealthView />
      </PageBody>
    </WhenRuns>
  );
}
